module.exports = __webpack_public_path__ + "img/logo_w.5586e80f.png";